import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SpPageAccessDeniedComponent } from './sp-page-access-denied/sp-page-access-denied.component';
import { SpPageMaintenanceComponent } from './sp-page-maintenance/sp-page-maintenance.component';
import { SpPageNotFoundRedirectComponent } from './sp-page-not-found-redirect/sp-page-not-found-redirect.component';
import { SpPageSomethingWrongComponent } from './sp-page-something-wrong/sp-page-something-wrong.component';
import { SpPageUserBlockedComponent } from './sp-page-user-blocked/sp-page-user-blocked.component';
import { SpPageSharedExpiredComponent } from './sp-page-shared-expired/sp-page-shared-expired.component';

const spPageRoutes: Routes = [
  {
    path: 'page-access-denied',
    component: SpPageAccessDeniedComponent
  },
  {
    path: 'page-maintenance',
    component: SpPageMaintenanceComponent
  },
  {
    path: 'page-not-found',
    component: SpPageNotFoundRedirectComponent
  },
  {
    path: 'page-something-wrong',
    component: SpPageSomethingWrongComponent
  },
  {
    path: 'page-user-blocked',
    component: SpPageUserBlockedComponent
  },
  {
    path: 'page-shared-expired',
    component: SpPageSharedExpiredComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(spPageRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SpPageRoutingModule {}
